<template>
    <section class="property-summary-title" :class="{'mortgage-rate-v3': isMortgageRateV3Layout, 'mortgage-rate-v4': getSplit('movoto-mortgage-rate-CW-4525','on4'), 'mortgage-rate-v2': getSplit('movoto-mortgage-rate-CW-4525','on2'), 'mortgage-rate-v1': getSplit('movoto-mortgage-rate-CW-4525','on1')}">
        <h1 class="singleline">
            <span class="text-bold">{{ dpp.geo.address }},</span>
            <a v-if="dpp.geo.city" class="hover-dotted"  :href="glb.appUrl + dpp.geo.cityPath" :title="`${dpp.geo.city}, ${dpp.geo.state} Homes for Sale`">{{ dpp.geo.city }}, {{ dpp.geo.state }}</a>
            <a v-if="dpp.geo.zipcode" class="hover-dotted" :href="glb.appUrl + dpp.geo.zipcodePath" :title="`${dpp.geo.zipcode}, ${dpp.geo.state} Real Estate and Homes for Sale`">{{ dpp.geo.zipcode }}</a>
        </h1>
        <div class="property-price">
            <template v-if="dpp.isRentals">
                <b v-if="dpp.price">{{$filters.formatPrice(dpp.price)}}<span class="f7">/Mo</span></b>
                <b v-else>Undisclosed</b>
            </template>
            <template v-else-if="dpp.isActive">
                <b v-if="dpp.price">
                    {{$filters.formatPrice(dpp.price)}}
                </b>
                <b v-else>Undisclosed</b>
            </template>
            <template v-else-if="lessThan12Months">
                <b v-if="dpp.price">{{$filters.formatPrice(dpp.price)}}</b>
                <b v-else-if="getEstimateInfo && getEstimateInfo.value > 0"><button class="btn-estimate" type="button" @click="openDisclaimer"></button> {{ $filters.formatPrice(getEstimateInfo.value) }}</b>
                <b v-else>Undisclosed</b>
            </template>
            <template v-else>
                <b v-if="getEstimateInfo && getEstimateInfo.value > 0"><button class="btn-estimate" type="button" @click="openDisclaimer"></button> {{ $filters.formatPrice(getEstimateInfo.value) }}</b>
                <b v-else-if="dpp.price">{{$filters.formatPrice(dpp.price)}}</b>
                <b v-else>Undisclosed</b>
            </template>
        </div>
        <template v-if="isMortgageRateV3Layout">
            <div class="property-mortgagerate" v-if="getMortgagePerMonth && !hideEstMonthCost"> <b>{{ $filters.formatPrice(getMortgagePerMonth) }}/mo</b></div>
            <div class="property-mortgagerate-label"> <span v-if="formattedMortgageRate">at {{ formattedMortgageRate + '%' }}</span> <button type="button" class="text-sentencecase link" style="text-decoration: underline;" @click="showForm(getPreApprovedObj, $event)">Get preapproved</button></div>
        </template>
        <div class="property-price-label" v-if="!dpp.isRentals">
            <template v-if="dpp.isActive">
                <template v-if="getSplit('movoto-mortgage-rate-CW-4525', 'on1')">
                    <button type="button" class="text-sentencecase link" style="text-decoration: underline;" @click="showForm(getPreApprovedObj, $event)">Get preapproved{{`${formattedMortgageRate ? ' as low as ' : ''}`}}<span class="text-bold" v-if="formattedMortgageRate">{{ formattedMortgageRate }}%</span></button><template v-if="getEstimatePriceRange"> &bull;</template>
                </template>
                <span class="property-estimate-label" v-if="getEstimatePriceRange">
                    <i class="icon-logo-m-new"></i><button type="button" class="underdash" v-scroll="'propertyEstimatePanel'">Est: </button>
                    <button type="button" class="link" v-scroll="'propertyEstimatePanel'">
                        {{getEstimatePriceRange}}
                    </button>
                </span>
                <span v-if="!getSplit('movoto-mortgage-rate-CW-4525')">
                    <template v-if="getEstimatePriceRange">•</template>
                    <button type="button" v-scroll="'propertyMortgagePanel'" v-if="getMortgagePerMonth && !hideEstMonthCost"><i class="icon-calculator"></i> Mtg: {{$filters.formatPrice(getMortgagePerMonth)}}/mo</button>
                    <button type="button" class="text-sentencecase link" style="text-decoration: underline;" @click="showForm(getPreApprovedObj, $event)">{{ getPreApprovedObj.cta }}</button>
                </span>
            </template>
            <template v-else-if="lessThan12Months">
                <p  data-allow-mismatch="text">
                    <span class="text-sentencecase" v-if="dpp.soldDate">Last sold {{$filters.formatDate(dpp.soldDate)}} {{dpp.soldTimeDisplay ? `after ${dpp.soldTimeDisplay}` : ''}}</span>
                    <span class="text-sentencecase" v-else>Last sold date unavailable</span>
                </p>
            </template>
            <template v-else>
                <p data-allow-mismatch="text">
                    <span class="text-sentencecase" v-if="dpp.soldDate">
                        <template v-if="getEstimateInfo && getEstimateInfo.value">
                            Last sold {{ $filters.formatDate(dpp.soldDate) }} {{ dpp.price ? `for ${$filters.formatFriendlyPrice(dpp.price)}` : ''}}
                        </template>
                        <template v-else>
                            Last sold {{ $filters.formatDate(dpp.soldDate) }} {{ dpp.soldTimeDisplay ? `after ${dpp.soldTimeDisplay}` : ''}}
                        </template>
                    </span>
                    <span class="text-sentencecase" v-else>
                        Last sold date unavailable
                    </span>
                </p>
            </template>
        </div>
        <ul  class="property-summary-group">
            <li>
                <b>{{ dpp.bed ? dpp.bed : '—' }}</b> <p>{{molang('dpp.dppTitle.bed')}}</p>
            </li>
            <li>
                <b>{{ dpp.bath ? dpp.bath : '—' }}</b> <p>{{molang('dpp.dppTitle.bath')}}</p>
            </li>
            <li v-if="dpp.area">
                <b>{{$filters.formatArea(dpp.area, dpp.isLand) }}</b>
                <p>
                    {{dpp.areaUnit}}
                    <span v-if="dpp.pricePerArea && !hidePricePreArea">({{$filters.formatPricePerArea(dpp.pricePerArea, dpp.isLand, dpp.isRentals)}}/{{dpp.areaUnit}})</span>
                </p>
            </li>
        </ul>
        <div class="property-status" :class="dpp.labelClass" v-if="dpp.labelName" >
            <i></i>
            <span data-allow-mismatch="text">{{formattedLabelName}}</span>
            <template v-if="newSoldPublicRecordCta && !dpp.isActive">
                <a v-if="isDigsSubscribed" class="btn secondary small hidden-sm hidden-md hidden-lg" :href="glb.appUrl + 'my-movoto/owned-homes/' + dpp.propertyId + '/'">Owner Dashboard</a>
                <button type="button" v-else class="btn secondary small hidden-sm hidden-md hidden-lg" @click="openDig()">{{ molang('dpp.hotButton.iAmOwner') }}</button>
            </template>
            <div style="display: flex; align-items: center; gap: var(--gxs);" :class="{'text-green': dpp.isPriceReduced, 'text-red': !dpp.isPriceReduced}" v-if="dpp.showPriceChange && !dpp.hideDaysOnMarket"> <b :class="dpp.isPriceReduced ? 'icon-arrow-down-circle-filled' : 'icon-send-ios'"></b> <span>{{$filters.formatFriendlyPrice(dpp.priceChange)}}</span> {{ dpp.isPriceReduced ? 'price drop' : 'price increase' }}</div>
        </div>
        <dppHotleadButton :requestTourSubtext="ctaRequestTourSubtext"  :requestVerticallLayout="ctaRequestVerticallLayout"/>
        <div class="mortgage-rate-item" v-if="getSplit('movoto-mortgage-rate-CW-4525', 'on2')">
            <div >
                <i class="icon-home-percent"></i>
                <div>
                    <div class="text-bold">Today’s low rate: <span v-if="formattedMortgageRate">{{ formattedMortgageRate + '%' }}</span></div>
                    <div class="text-gray" v-if="getMortgagePerMonth && !hideEstMonthCost">Estimated mortgage <button type="button" v-scroll="'propertyMortgagePanel'" class="underdash">{{ $filters.formatPrice(getMortgagePerMonth) }}/mo.</button></div>
                </div>
                <button type="button" class="text-sentencecase link text-bold" @click="showForm(getPreApprovedObj, $event)">Get preapproved</button>
            </div>
            <div>
                <i class="icon-poi-bank"></i>
                <div>
                    <div class="text-bold">Low money down</div>
                    <div class="text-gray">Do you qualify for low money down?</div>
                </div>
                <button type="button" class="link text-bold" @click="show3way($event)">Check eligibility</button>
            </div>
        </div>
        <div class="property-sumary-footer" v-else>
            <button v-if="getSplit('movoto-calcpayment-cw-12068', 'on17')" type="button" class="link" @click="show3way($event)" >
                {{ getQualifyLowMoneyDownCta }}
            </button>
            <button v-else-if="getSplit('movoto-calcpayment-cw-12068')" type="button" class="link" @click="show3way($event)" >
                Do You Qualify for Low Money Down? Check Eligibility
            </button>
            <button v-else-if="showVeteransDrawLink"  class="link"  @click="openVeteransHotlead({leadType : 'VeteranDPPSection'})">
                Veterans: Find an agent familiar with $0 down VA loans
            </button>
            <div v-if="glb.transactionCount > 10">
                {{glb.transactionCount}} homes bought nearby with <span @click="showTransDialog" class="underdash" role="button">Movoto</span> recently
            </div>
            <div v-else-if="glb.agentCount > 5">
                <span @click="showTransDialog" class="underdash" role="button">Movoto</span> is helping {{glb.agentCount}} homebuyers near you
            </div>
            <div v-else>
                Learn about {{glb.geo.city}}'s top <span @click="showTransDialog" class="underdash"  role="button">local Real Estate agents</span>
            </div>
        </div>
    </section>
</template>
<script src="./property-summary-title.js"></script>

<style lang="scss">
@use './property-summary-title.scss' as *;
</style>
